export default "__VITE_ASSET__DLATameH__"